import React from 'react';
import './Home.css';

function Home({ onNavigate }) {
  const categories = [
    { name: 'Wood Grain', icon: '🪵', desc: 'Natural textures' },
    { name: 'Solid Colors', icon: '🎨', desc: 'Vibrant finishes' },
    { name: 'Stone & Marble', icon: '🪨', desc: 'Elegant patterns' },
    { name: 'Textured', icon: '🤚', desc: 'Unique surfaces' },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-pattern"></div>
        </div>
        <div className="hero-content">
          <h1>Premium Decorative Laminates</h1>
          <p className="tagline">Refining spaces. Defining you.</p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => { window.history.pushState({}, '', '/laminates'); window.dispatchEvent(new PopStateEvent('popstate')); }}>
              Explore Collection
            </button>
            <button className="btn-secondary" onClick={() => { window.history.pushState({}, '', '/contact'); window.dispatchEvent(new PopStateEvent('popstate')); }}>
              Get in Touch
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="features-container">
          <div className="feature">
            <div className="feature-icon">✨</div>
            <h3>Curated Designs</h3>
            <p>Handpicked collection of premium laminate patterns</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🛡️</div>
            <h3>Quality Materials</h3>
            <p>Sourced from trusted manufacturers</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🌈</div>
            <h3>Diverse Range</h3>
            <p>Options for every style and budget</p>
          </div>
        </div>
      </section>

      {/* Categories Preview */}
      <section className="categories-section">
        <div className="categories-container">
          <h2>Explore Our Collection</h2>
          <p className="section-subtitle">Find the perfect laminate for your project</p>
          <div className="categories-grid">
            {categories.map((cat, index) => (
              <div 
                key={index} 
                className="category-card"
                onClick={() => { window.history.pushState({}, '', '/laminates'); window.dispatchEvent(new PopStateEvent('popstate')); }}
              >
                <span className="category-icon">{cat.icon}</span>
                <h3>{cat.name}</h3>
                <p>{cat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2>Ready to Transform Your Space?</h2>
          <p>Browse our extensive collection of decorative laminates</p>
          <button className="btn-primary" onClick={() => window.location.hash = 'laminates'}>
            View All Laminates
          </button>
        </div>
      </section>
    </div>
  );
}

export default Home;
